<template>
  <div id="app">
    <div class="DoctorConsultation">
      <div class="DoctorConsultation__text">
        <span>Limited time offer:</span>
        <a
          href="https://getcurex.com/promo"
          class="DoctorConsultation__link"
          target="_self"
        >
          Free Doctor Consultation
        </a>
      </div>
    </div>
    <Header />
    <div>
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: "Freizeit";
  src: url("../public/assets/fonts/Freizeit-Regular.eot");
  src: url("../public/assets/fonts/Freizeit-Regular.eot?#iefix")
      format("embedded-opentype"),
    url("../public/assets/fonts/Freizeit-Regular.svg#Freizeit-Regular")
      format("svg"),
    url("../public/assets/fonts/Freizeit-Regular.ttf") format("truetype"),
    url("../public/assets/fonts/Freizeit-Regular.woff") format("woff"),
    url("../public/assets/fonts/Freizeit-Regular.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Freizeit";
  src: url("../public/assets/fonts/Freizeit-Bold.eot");
  src: url("../public/assets/fonts/Freizeit-Bold.eot?#iefix")
      format("embedded-opentype"),
    url("../public/assets/fonts/Freizeit-Bold.svg#Freizeit-Bold") format("svg"),
    url("../public/assets/fonts/Freizeit-Bold.ttf") format("truetype"),
    url("../public/assets/fonts/Freizeit-Bold.woff") format("woff"),
    url("../public/assets/fonts/Freizeit-Bold.woff2") format("woff2");
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

body {
  font-family: Freizeit, Arial, sans-serif;
}

.h4,
.h5,
.h6,
h4,
h5,
h6 {
  font-weight: 600;
}

.DoctorConsultation {
  background: linear-gradient(90deg, #05e28b 0%, #1582c7 100%);
  font-size: 12px;
  line-height: 20px;
  color: white;
  text-align: center;
  padding: 0.5rem;
  font-family: Freizeit, Arial, sans-serif;

  &__text {
    text-transform: uppercase;
  }

  &__link {
    text-transform: none;
    text-decoration: underline;
    margin-left: 5px;
    color: white;
  }
}
</style>
